const HeroSection = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden"
      style={{ minHeight: '580px' }}
    >
      {/* 背景画像 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20construction%20company%20warehouse%20interior%20with%20neatly%20organized%20construction%20materials%20on%20metal%20shelving%20racks%2C%20company%20service%20vehicles%20parked%20outside%20modern%20clean%20office%20building%2C%20bright%20natural%20lighting%2C%20industrial%20professional%20setting%2C%20organized%20inventory%20management%2C%20Japan%20construction%20company&width=1440&height=600&seq=hero001&orientation=landscape"
          alt="自社倉庫・事務所外観"
          className="w-full h-full object-cover object-top"
        />
        {/* オーバーレイ */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/25"></div>
      </div>

      {/* コンテンツ */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center" style={{ minHeight: '580px', paddingTop: '96px', paddingBottom: '64px' }}>
        {/* ラベル */}
        <div className="mb-5">
          <span
            className="inline-block text-xs font-semibold px-3 py-1.5 rounded tracking-widest"
            style={{ backgroundColor: '#2C5AA0', color: '#fff', letterSpacing: '0.12em' }}
          >
            自社倉庫完備 ｜ 有資格者施工
          </span>
        </div>

        {/* メインキャッチコピー */}
        <h1 className="text-white font-bold leading-snug mb-4" style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', maxWidth: '640px', letterSpacing: '0.02em' }}>
          確かな技術と、充実の工務体制。<br />
          自社倉庫完備で、迅速な<br className="sm:hidden" />
          資材確保と施工を実現します。
        </h1>

        {/* サブコピー */}
        <ul className="mb-8 space-y-2 sm:space-y-0 sm:flex sm:gap-6">
          {[
            '自社資材倉庫保有',
            '緊急対応可能',
            '有資格者による責任施工',
          ].map((item) => (
            <li key={item} className="flex items-center gap-2 text-white/90 text-sm sm:text-base">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-base" style={{ color: '#7EC8E3' }}></i>
              </div>
              <span className="font-medium">{item}</span>
            </li>
          ))}
        </ul>

        {/* CTAボタン */}
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => scrollTo('contact')}
            className="px-7 py-3.5 text-sm font-bold rounded-md transition-colors cursor-pointer whitespace-nowrap w-full sm:w-auto"
            style={{ backgroundColor: '#2C5AA0', color: '#fff' }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#234d8c')}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#2C5AA0')}
          >
            <span className="flex items-center justify-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-base"></i>
              </div>
              お問い合わせ・ご相談
            </span>
          </button>
          <button
            onClick={() => scrollTo('business')}
            className="px-7 py-3.5 text-sm font-bold rounded-md border-2 transition-colors cursor-pointer whitespace-nowrap w-full sm:w-auto"
            style={{ borderColor: '#fff', color: '#fff', backgroundColor: 'transparent' }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
          >
            <span className="flex items-center justify-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-s-line text-base"></i>
              </div>
              事業内容を見る
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
